import { useAppSelector } from "@/app/hooks";
import { Property } from "@/features/survey/types";
import { CommentsSheet } from "@/shared/components/CommentsSheet";
import { isCommentEnabled } from "@/shared/utils/propertyUtils";
import { EmeraldIconButton } from "@emerald-react/icon-button";
import { MouseEvent, useState } from "react";
import { selectHasPropertyComments } from "@/features/comments/commentsSlice";

interface ButtonCommentsProps {
  size?: "Medium" | "Small";
  property: Property;
}

export const ButtonComments = ({ property, size }: ButtonCommentsProps) => {
  const { currentSurvey, currentSurveyGroup } = useAppSelector(
    (state) => state.interactiveSurvey,
  );
  const surveyId = currentSurvey?.id || "";
  const [isCommentsSheetOpen, setIsCommentsSheetOpen] = useState(false);

  // Check if property has comments using the existing selector
  const hasComments = useAppSelector(
    (state) =>
      selectHasPropertyComments(state, property.id, surveyId) ||
      selectHasPropertyComments(state, property.propertyId || "", surveyId),
  );

  const handleClick = (event: MouseEvent<Element>) => {
    event.stopPropagation();
    // Open the comments sheet
    setIsCommentsSheetOpen(true);
  };

  // Don't render if comments are disabled for this survey/group, or if there is no active survey
  if (!currentSurvey || !isCommentEnabled(currentSurvey, currentSurveyGroup)) {
    return null;
  }

  return (
    <>
      <EmeraldIconButton
        type={hasComments ? "Primary" : "Secondary"}
        onClick={handleClick}
        size={size}
        className="emerald-btn"
        icon={hasComments ? "mark_unread_chat_alt" : "sms"}
        iconFillType="outlined"
      />

      {/* Comments Sheet */}
      <CommentsSheet
        isOpen={isCommentsSheetOpen}
        onClose={() => setIsCommentsSheetOpen(false)}
        property={property}
        survey={currentSurvey}
      />
    </>
  );
};

export default ButtonComments;
